module.exports = __webpack_public_path__ + "static/media/course-background.0045cc46.jpg";